import { supabase } from "@/integrations/supabase/client";
import { 
  getPendingSyncItems, 
  markSyncItemComplete, 
  markSyncItemError,
  clearSyncedItems 
} from "./db";

export async function syncWithServer(): Promise<{ success: number; failed: number }> {
  const items = await getPendingSyncItems();
  let success = 0;
  let failed = 0;

  for (const item of items) {
    try {
      switch (item.operation) {
        case 'insert':
          await (supabase as any).from(item.table).insert(item.data);
          break;
        case 'update':
          await (supabase as any).from(item.table).update(item.data).eq('id', item.data.id);
          break;
        case 'delete':
          await (supabase as any).from(item.table).delete().eq('id', item.data.id);
          break;
      }
      
      await markSyncItemComplete(item.id);
      success++;
    } catch (error) {
      console.error('Sync error for item:', item.id, error);
      await markSyncItemError(item.id, String(error));
      failed++;
    }
  }

  // Clean up synced items
  if (success > 0) {
    await clearSyncedItems();
  }

  return { success, failed };
}

export function setupAutoSync() {
  // Sync on reconnect
  window.addEventListener('online', () => {
    if (import.meta.env.DEV) console.log('Back online - starting sync...');
    syncWithServer().then(result => {
      if (import.meta.env.DEV) console.log('Auto-sync completed:', result);
    });
  });

  // Periodic sync every 5 minutes when online
  setInterval(() => {
    if (navigator.onLine) {
      syncWithServer();
    }
  }, 5 * 60 * 1000);
}
